module.exports = __webpack_public_path__ + "static/media/schema.13e6dc2b.png";